module.exports = __webpack_public_path__ + "static/media/im.f7622393.svg";